export default __webpack_public_path__ + "static/media/I_Iogurte.a157a524.svg";